import siteSearchGroup from '@/components/search-group.vue'
import { mailReport } from '@/api/mail'
import { EMAILSTATUS } from '@/utils/dict'
import detailDialog from './detail.dialog.vue'
import { mapGetters } from 'vuex'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { encode } from 'js-base64'
import { mapActions } from 'vuex'

const columns = [
  {
    title: '',
    enTitle: 'To',
    width: 160,
    dataIndex: 'toMail',
    slot: 'emails',
  },
  {
    title: '',
    enTitle: 'CC',
    width: 160,
    dataIndex: 'cc',
    slot: 'emails',
  },
  {
    title: '',
    enTitle: 'BCC',
    width: 160,
    dataIndex: 'bcc',
    slot: 'emails',
  },
  {
    title: '',
    enTitle: 'Title',
    width: 200,
    dataIndex: 'subject',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'Status',
    width: 120,
    dataIndex: 'status',
    slot: 'status',
  },
  {
    title: '',
    enTitle: 'Attachment',
    width: 200,
    dataIndex: 'fileList',
    slot: 'templateList',
  },
  {
    title: '',
    enTitle: 'Action Email',
    width: 200,
    dataIndex: 'operator',
    slot: 'operator',
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 200,
    dataIndex: 'operatorTime',
    slot: 'time',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 70,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
export default {
  components: {
    siteSearchGroup,
    detailDialog,
  },
  data() {
    return {
      params: {
        operated: true,
        toed: true,
        cced: true,
        bcced: true,
      },
      date: [],
      showAdv: false,
      statusList: EMAILSTATUS,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        showSizeChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true,
      },
      columns: columns,
      isVisable: false,
      id: '',
      dataSource: [],
      operatorStartTime: null,
      operatorEndTime: null,
      subject: '',
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
    }),
  },
  mounted() {
    this.getList()
    help.closeAutocomplete()
  },
  methods: {
    ...mapActions(['updateLoading']),
    async getList(page, size) {
      const subject = encode(this.subject)
      // const subject = window.btoa(this.subject)
      if (!page) {
        page = 1
      }
      if (!size) {
        size = this.pagination.size
      }
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: size,
        subject,
      })
      this.updateLoading(true)
      const { list, pageIndex, pageSize, total } = await mailReport.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex,
      })
      this.updateLoading(false)
    },
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    handleDateChange(date) {
      this.params.operatorStartTime = date[0] ? date[0].startOf('d') : ''
      this.params.operatorEndTime = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    handleClear() {
      this.params.email = ''
      this.params.subject = ''
      this.params.operatorStartTime = ''
      this.params.operatorEndTime = ''
      this.params.status = ''
      this.subject = ''
      this.date = []
      this.getList()
    },
    detail(val) {
      this.id = val.id
      this.isVisable = true
    },
    cancel() {
      this.isVisable = false
    },
  },
}
